// components/FormularSesizare/steps/ValidationStep.jsx

import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import Icon from "@mui/material/Icon";
import { primaryBtnSx, outlineAccentBtnSx, infoAlertSx } from "../colors";

function ValidationStep({
  email,
  countdown,
  validationCode,
  validationError,
  handleCodeChange,
  handleValidateCode,
  handleTrimiteCodNou,
  customColors
}) {
  const formattedTime = `${Math.floor(countdown / 60)}:${(countdown % 60).toString().padStart(2, '0')}`;

  return (
    <SoftBox p={3}>
      <SoftTypography variant="h5" fontWeight="bold" mb={3} color={customColors.primary.main}>
        Validare adresă de email
      </SoftTypography>

      <Alert severity="info" sx={{ mb: 3, ...infoAlertSx }}>
        Un cod de validare a fost trimis pe adresa de email <strong>{email}</strong>.
        Vă rugăm să introduceți codul pentru a continua.
        {countdown > 0 && (
          <SoftTypography variant="caption" display="block" mt={1}>
            Codul este valabil pentru {formattedTime} minute.
          </SoftTypography>
        )}
      </Alert>

      <SoftBox mb={3}>
        <SoftBox mb={1} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" color={customColors.secondary.main}>
            Cod de validare*
          </SoftTypography>
        </SoftBox>
        <SoftInput
          placeholder="Introduceți codul primit pe email"
          value={validationCode}
          onChange={handleCodeChange}
          icon={{
            component: "lock",
            direction: "left"
          }}
        />
      </SoftBox>

      {validationError && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {validationError}
        </Alert>
      )}

      <SoftBox display="flex" justifyContent="center">
        {countdown === 0 ? (
          <SoftButton variant="outlined" onClick={handleTrimiteCodNou} sx={outlineAccentBtnSx}>
            Trimite un nou cod
          </SoftButton>
        ) : (
          <SoftButton variant="contained" onClick={handleValidateCode} sx={primaryBtnSx}>
            Validează codul
          </SoftButton>
        )}
      </SoftBox>
    </SoftBox>
  );
}

ValidationStep.propTypes = {
  email: PropTypes.string.isRequired,
  countdown: PropTypes.number.isRequired,
  validationCode: PropTypes.string.isRequired,
  validationError: PropTypes.string,
  handleCodeChange: PropTypes.func.isRequired,
  handleValidateCode: PropTypes.func.isRequired,
  handleTrimiteCodNou: PropTypes.func.isRequired,
  customColors: PropTypes.shape({
    primary: PropTypes.shape({
      main: PropTypes.string,
    }),
    secondary: PropTypes.shape({
      main: PropTypes.string,
    }),
  }).isRequired,
};

export default ValidationStep;
